import React, { Component } from "react";
import { Card, Button } from "reactstrap";

import { getMessage } from "CONFIG/i18n";

import "./ScreenMasking.less";

export default class ScreenShare extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div id="screenMaskingDiv" className="screenMaskingDiv">
        { this.props.isScreenMasking && !(this.props.presenterId === this.props.uniqueId) ? (
          <Card className="displayFlex screenMaskingCard">
            <div className="perfectCenter">
              <div className="screenMaskingMsg">
                {getMessage("SCREEN_MASKING_ENABLE")}
              </div>
            </div>
          </Card>
        ): null }
      </div>
    )
  }
}
